import React, { useState } from "react";
import {
  useMediaQuery,
  WhmBox,
  WhmDialog,
  WhmDialogContent,
  WhmDialogActions,
  WhmIconButton,
  WhmTypography,
  WhmButton,
  Theme,
  WhmDialogTitle,
} from "@securitize/reactjs-whm";
import { useTheme } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import verifyProfile from "../../../assets/verify-profile.svg";
import useTranslations from "../../../hooks/useTranslations";
import { translationKeys } from "../../../contexts/I18nContext";
import { REDIRECT } from "./Inputs/constants";

const VerifyProfileModal = () => {
  const { getTranslation: t } = useTranslations();
  const redirectUrl = REDIRECT.KYC_URL.replaceAll(
    "{REDIRECT_URL}",
    window.location.href,
  );
  const [isOpen, setIsOpen] = useState(true);
  const redirectToKycProcess = () => {
    window.location.href = redirectUrl;
  };

  const onClose = () => {
    setIsOpen(false);
  };

  const whmTheme = useTheme();
  const isMobile = useMediaQuery(whmTheme.breakpoints.down("xl"));

  return (
    <WhmDialog
      open={isOpen}
      onClose={onClose}
      fullScreen={isMobile}
      {...(!isMobile && { maxWidth: "xs" })}
      {...(isMobile && { maxWidth: "lg" })}
      aria-labelledby="verify-profile-modal-title"
      aria-describedby="verify-profile-modal-description"
    >
      <WhmDialogTitle
        id="verify-profile-modal-title"
        variant="h4"
        sx={{ display: "flex", justifyContent: "space-between" }}
      >
        {t(translationKeys.FORM_VERIFY_PROFILE_MODAL_TITLE)}
        <WhmIconButton
          disableRipple
          aria-label="close"
          onClick={onClose}
          size="small"
          sx={(theme: Theme) => ({
            padding: 0,
            color: theme.palette.common.black,
          })}
        >
          <CloseIcon />
        </WhmIconButton>
      </WhmDialogTitle>
      <WhmDialogContent
        sx={{
          pt: 5,
          pb: 3,
          px: 3,
        }}
      >
        <WhmBox sx={{ textAlign: "center" }}>
          <img
            src={verifyProfile}
            alt="Verify Profile"
            style={{ width: 124, height: 124 }}
          />
        </WhmBox>

        <WhmTypography
          id="verify-profile-modal-description"
          variant="body1"
          sx={{ mt: "1rem" }}
        >
          {t(translationKeys.FORM_VERIFY_PROFILE_MODAL_TEXT)}
        </WhmTypography>
        <WhmTypography
          id="verify-profile-modal-estimated"
          variant="body2"
          color="text.secondary"
          sx={{ mt: "1rem" }}
        >
          {t(translationKeys.FORM_VERIFY_PROFILE_MODAL_ESTIMATED)}
        </WhmTypography>
      </WhmDialogContent>

      <WhmDialogActions
        sx={{ justifyContent: isMobile ? "flex-end" : "flex-end" }}
      >
        <WhmButton
          variant="outlined"
          color="secondary"
          size="medium"
          onClick={onClose}
        >
          {t(translationKeys.FORM_VERIFY_PROFILE_MODAL_CANCEL)}
        </WhmButton>
        <WhmButton
          variant="contained"
          size={"medium"}
          color="primary"
          onClick={redirectToKycProcess}
        >
          {t(translationKeys.FORM_VERIFY_PROFILE_MODAL_BUTTON)}
        </WhmButton>
      </WhmDialogActions>
    </WhmDialog>
  );
};

export default VerifyProfileModal;
